const round = (number: number) => Math.round(number * 100) / 100

const performanceReducerEnhancer = (createStore:any) => (
  reducer: any,
  initialState: any,
  enhancer: any
): any => {
  const performanceReducer = (state: any, action: any) => {
    const start = performance.now();
    const newState = reducer(state, action);
    const end = performance.now();
    const diff = round(end - start);

    // console.log('Reducer performance:', diff);

    return newState;
  }

  return createStore(performanceReducer, initialState, enhancer);
}

export default performanceReducerEnhancer;